//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
	name: 'OverviewSuccess',
	data: () => ({
		loading: false,
	}),
	computed: {
		...mapGetters('vehicle', ['pushedVehicles']),
	},
	methods: {

		/*
		async loadMore() {
			this.loading = true;
			await new Promise(resolve => setTimeout(resolve, 600));
			this.vehicles.push(
				...list(),
			);
			this.loading = false;
		},
		*/
	},
};
